import PropTypes from 'prop-types'

import { getHighlightSegments } from '../../../utils/listSearch'

import styles from './HighlightedText.module.scss'

/**
 * Renders text with query matches highlighted (e.g. light yellow).
 * Uses token-based matching so "6 Orlando" highlights "6" and "Orlando" in order.
 * Reusable for any list autosuggest / search result.
 */
export const HighlightedText = ({ text, query, className, highlightClassName }) => {
  if (query == null || String(query).trim() === '') {
    return <span className={className}>{text}</span>
  }

  const segments = getHighlightSegments(text, String(query))

  return (
    <span className={className}>
      {segments.map((seg, i) =>
        seg.highlight ? (
          <span key={i} className={highlightClassName || styles.highlight}>
            {seg.text}
          </span>
        ) : (
          seg.text
        )
      )}
    </span>
  )
}

HighlightedText.propTypes = {
  text: PropTypes.string.isRequired,
  query: PropTypes.string,
  className: PropTypes.string,
  highlightClassName: PropTypes.string
}

export default HighlightedText
